/** @format */

export type Brand = 'DSG' | 'GG' | 'GGG' | 'G3' | 'PL' | 'MJ';
export type Platform = 'MWEB' | 'DESKTOP';
export type PageType = 'PLP' | 'SRLP' | 'PDP' | 'OCP';
export type PlacementType = 'INGRID' | 'CAROUSEL' | 'DST' | 'VIDEO';
export type PlacementLevel = 'PLACEMENT' | 'PRODUCT';
export type BeaconType = 'LOAD' | 'VIEW' | 'CLICK' | 'BASKETCHANGE' | 'ADDTOWISHLIST';

export interface UserInformation {
  adobeMCVID: string;
  email?: string;
  athleteId?: number;
  optedOut: boolean;
  swimlane?: string;
}

export interface ProductInformation {
  parentItem: string;
  item: number;
  price: number;
  availability: number;
  category?: string;
}

export interface PlpProductInformation {
  /** The product category id, e.g. "202040>202182>202186" */
  category: string;
  listSize?: number;
  pageNumber?: number;
  filters?: Record<string, string[]>;
}

export interface SrlpProductInformation {
  searchTerm: string;
  listSize?: number;
  pageNumber?: number;
  filters?: Record<string, string[]>;
}

export interface TransactionInformation {
  items: number[];
  prices: number[];
  quantities: number[];
  transactionId: string;
  currency?: string;
}

export interface PdpRequestBody {
  brand: Brand;
  platform: Platform;
  userInformation: UserInformation;
  productInformation: ProductInformation;
}

export interface PlpRequestBody {
  brand: Brand;
  platform: Platform;
  userInformation: UserInformation;
  plpProductInformation: PlpProductInformation;
}

export interface SrlpRequestBody {
  brand: Brand;
  platform: Platform;
  userInformation: UserInformation;
  srlpProductInformation: SrlpProductInformation;
}

export interface OcpRequestBody {
  brand: Brand;
  platform: Platform;
  userInformation: UserInformation;
  transactionInformation: TransactionInformation;
}

export interface BeaconRequestBody {
  beacon: string;
  referer: string;
}

export interface BeaconQueryParameters {
  placementType: PlacementType;
  placementLevel: PlacementLevel;
  beaconType: BeaconType;
}
